import { render } from "./DividendsPay.vue?vue&type=template&id=6f3fb8bc&scoped=true"
import script from "./DividendsPay.vue?vue&type=script&lang=js"
export * from "./DividendsPay.vue?vue&type=script&lang=js"

import "./DividendsPay.vue?vue&type=style&index=0&id=6f3fb8bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3fb8bc"]])

export default __exports__